import React from 'react';
import { Calendar, FileCheck, Headphones } from 'lucide-react';

const ProcessSection = () => {
  const steps = [
    {
      icon: Calendar,
      title: 'Bedarfsanalyse vor Ort',
      description: 'Wir besichtigen Ihr Objekt persönlich, analysieren Ihre spezifischen Anforderungen und beraten Sie individuell. Kostenfrei und unverbindlich.',
      details: ['Objektbesichtigung', 'Bedarfsermittlung', 'Fachberatung'],
      number: '01',
    },
    {
      icon: FileCheck,
      title: 'Transparentes Festpreisangebot',
      description: 'Sie erhalten ein detailliertes Angebot mit klaren Leistungsbeschreibungen und festen Preisen. Keine versteckten Kosten, keine Überraschungen.',
      details: ['Fixpreise', 'Detaillierte Leistungen', 'Klare Konditionen'],
      number: '02',
    },
    {
      icon: Headphones,
      title: 'Umsetzung & Qualitätsmanagement',
      description: 'Feste Ansprechpartner betreuen Sie dauerhaft. Dokumentierte Reinigungsabläufe, regelmäßige Kontrollen und schnelle Reaktion bei Sonderwünschen.',
      details: ['Fester Ansprechpartner', 'Dokumentierte Prozesse', 'Regelmäßige Kontrollen'],
      number: '03',
    },
  ];

  return (
    <section id="process" className="py-16 sm:py-20 lg:py-24 bg-gradient-to-b from-[#F9FAFB] to-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16 fade-in">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#0A2846] mb-6 px-2">
            So einfach geht’s
          </h2>
          <div 
            className="w-24 sm:w-32 h-1.5 mx-auto mb-6 sm:mb-8 rounded-full"
            style={{ 
              background: 'linear-gradient(90deg, #D4AF37 0%, #FFD700 50%, #F4D03F 100%)',
              boxShadow: '0 4px 15px rgba(212, 175, 55, 0.4)'
            }} 
          />
          <p className="text-lg sm:text-xl text-[#1F2937] max-w-3xl mx-auto leading-relaxed px-4">
            Von der ersten Anfrage bis zur regelmäßigen Betreuung – transparent, professionell und zuverlässig
          </p>
        </div>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-1" 
            style={{ 
              background: 'linear-gradient(90deg, #D4AF37 0%, #FFD700 50%, #F4D03F 100%)',
              opacity: 0.3,
              zIndex: 0
            }} 
          />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10">
            {steps.map((step, index) => {
              const Icon = step.icon;
              return (
                <div key={index} className="relative">
                  <div className="bg-white p-8 rounded-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 border-2 border-gray-100 relative">
                    <div 
                      className="absolute -top-8 left-1/2 transform -translate-x-1/2 w-16 h-16 rounded-full flex items-center justify-center font-bold text-2xl shadow-lg"
                      style={{
                        background: 'linear-gradient(135deg, #D4AF37 0%, #FFD700 100%)',
                        color: '#0A2846',
                        boxShadow: '0 8px 25px rgba(212, 175, 55, 0.5)'
                      }}
                    >
                      {step.number}
                    </div>
                    <div className="mt-8">
                      <div className="flex justify-center mb-6">
                        <Icon className="w-16 h-16 text-[#0A2846]" />
                      </div>
                      <h3 className="text-2xl font-semibold text-[#0A2846] mb-4 text-center">{step.title}</h3>
                      <p className="text-[#1F2937]/80 leading-relaxed mb-6 text-center">{step.description}</p>
                      <ul className="space-y-2">
                        {step.details.map((detail, idx) => (
                          <li key={idx} className="flex items-center text-sm text-[#1F2937]/70">
                            <div 
                              className="w-2 h-2 rounded-full mr-3"
                              style={{ background: 'linear-gradient(135deg, #D4AF37, #FFD700)' }}
                            />
                            {detail}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;